var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBox',{attrs:{"data-cy":"biometry-camera-button"}},[(_vm.shouldRequestResources)?_c('resouce-modal',{attrs:{"useMic":false}}):_vm._e(),_c('OmtButton',_vm._b({attrs:{"disabled":_vm.disableButton},on:{"click":_vm.handleStart}},'OmtButton',Object.assign({}, Object.assign({}, {variant: 'solid',
        width: '100%'},
        _vm.$attrs)),false),[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }